// eslint-disable-next-line max-len
const WARNING_MESSAGE = 'Due to demand, this unit is not available for online reservations. Call or visit the store to rent this unit.';

export { WARNING_MESSAGE };
